import React from 'react'

const DivisorLine = ({
    className,
    style = {
        height: "30px"
    }
}) => (
    <div
        style={{
            ...style,
            backgroundImage: "url(/img/bdz-divisor-line.png)",
            backgroundRepeatY: "no-repeat"
        }} 
        className={`w-100 ${className}`} />
)

export default DivisorLine